<template>
  <div class="rui-empty" :class="componentCSS">
    <rui-icon :name="icon" :size="inline ? null : iconSize" class="rui-empty__icon" />
    <div :class="small ? '-text--small' : ''">
      <!-- @slot Text to describe the empty state -->
      <slot>{{ content }}</slot>
    </div>
    <div v-if="$slots.actions" class="rui-empty__actions">
      <!-- @slot Optional actions (refresh button, ...) -->
      <slot name="actions" />
    </div>
  </div>
</template>
<script>
import RuiIcon, { sizes as iconSizes } from '../../Icon/Icon.vue'

/**
 * This component is used to notify that there is nothing to display: the list is empty, article has no content, etc...
 *
 * @preset Default { "props": { "content": "Nothing to display" } }
 * @preset With actions { "props": { "content": "Nothing to display" }, "slots": { "actions": "<button type='button' class='rui-button rui-button--creative'>Reload</button>" } }
 * @propsGroup Display [iconSize, inline, small]
 * @propsGroup Content [icon, content]
 */
export default {
  name: 'RuiEmpty',
  components: { RuiIcon },
  props: {
    /** Icon to represent the empty state */
    icon: { required: false, type: String, default: 'rui:empty' },
    /**
     * Size of the icon. Don't work when `inline` is true
     *
     * @values 10, 4, 3
     */
    iconSize: { required: false, type: [String, Number], default: 10, validate: (v) => iconSizes.includes(v) },
    /** Whether to render the component inline */
    inline: { required: false, type: Boolean, default: false },
    /** Whether to render the component smaller */
    small: { required: false, type: Boolean, default: false },
    /** Text content. Is overridden by default slot */
    content: { required: false, type: String, default: null },
  },
  computed: {
    componentCSS () {
      return [
        this.$props.inline && 'rui-empty--inline',
      ]
    },
  },
}
</script>
